import { CheckboxOptionType, Radio } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import colors from '~/constants/colors';

interface Props {
  value?: any;
  onChange?: (value: any) => void;
  options: CheckboxOptionType[];
}

const RadioGroupInput: FC<Props> = (props): JSX.Element => {
  return (
    <Container>
      <Radio.Group optionType="button" {...props} />
    </Container>
  );
};

const Container = styled.div`
  .ant-radio-group {
    display: flex;
    flex-direction: row;
  }

  .ant-radio-button-wrapper-checked,
  .ant-radio-button-wrapper-checked:hover,
  .ant-radio-button-wrapper-checked:focus-within,
  .ant-radio-button-wrapper-checked:first-child {
    box-shadow: 0 0 0;
    background-color: ${colors.grey[200]};
    border-color: ${colors.borderColorBase} !important;
  }

  .ant-radio-button-wrapper-checked::before,
  .ant-radio-button-wrapper-checked:hover::before {
    background-color: ${colors.borderColorBase};
  }

  .ant-radio-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .ant-radio-button-wrapper:hover,
  .ant-radio-button-wrapper-checked {
    color: ${colors.textColor};
    font-weight: 600;
  }
`;

export default RadioGroupInput;
